module.exports = __webpack_public_path__ + "img/08323e7.png";